{
    "Policies_Board.status.submitted": "Submitted",
    "Policies_Board.status.quoteIssued": "Quote Issued",
    "Policies_Board.status.quoteAccepted": "Quote Accepted",
    "Policies_Board.status.bindRequested": "Bind Requested",

    "Policies_Board.type.renewal": "Renewal",
    "Policies_Board.type.newBusiness": "New Business",
    "Policies_Board.type.none": "None",

    "Policies_Board.filter.type": "Type",
    "Policies_Board.filter.allTransactionType": "All Transaction Type",
    "Policies_Board.filter.renewals": "Renewals",
    "Policies_Board.filter.newBusinesses": "New Businesses",

    "Policies_Board.card.unassigned": "Unassigned",
    "Policies_Board.card.status": "Status",
    "Policies_Board.card.product": "Product",
    "Policies_Board.card.effective": "Effective",
    "Policies_Board.card.description": "Description",
    "Policies_Board.card.address": "Address",
    "Policies_Board.card.call": "Call",
    "Policies_Board.card.email": "Email",

    "Policies_Board.navigation.previous": "<<",
    "Policies_Board.navigation.next": ">>"
}
